import type { FaireProductEntity } from "../../entity_types/product";

export const p_2mdef3w4yn: FaireProductEntity = {
  token: "p_2mdef3w4yn",
  type: "product",
  name: "Rose Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/23825eca4912d578475f22b190d9e74b999208fcdfd908f4ffdff4ce6d8de71e.jpeg",
  galleryImageUrls: [],
  priceDollars: 20,
  description:
    "Single note scented candle hand-poured and crafted in Los Angeles exclusively by Putnam Design\n\n9 oz of Soy wax\n40 hour burn time\nTrim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:34.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
